<app-legal-page titleKey="LEGAL.COOKIES.TITLE" [introKey]="introKey" [sections]="sections"></app-legal-page>